// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","737":"fb7d5399","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"e9c9497477c4cf7c9381","737":"7317ccb1fba0c1499f55","883":"6eac23652969190b7d9d"}[chunkId] + ".js";
};